import {useSection} from "../Section/useSection";

export const useContainer = ({sectionId, containerId}) => {
    const section = useSection(sectionId)
    return section?.containers[containerId]

}